// extracted by mini-css-extract-plugin
export var ticketLink = "ticket-bubble-modules--ticketLink--1Udio";
export var strikethrough = "ticket-bubble-modules--strikethrough--2mtgk";
export var ticketLinkInner = "ticket-bubble-modules--ticketLinkInner--32F9O";